'use strict';

var isClient = typeof window !== 'undefined';
var ua = isClient ? require('@ali/simple-ua') : {};
var isUcBrowser = isClient ? require('../../utils/is_uc_browser') : {};

/**
 * 目前的黑名单：
 * iOS 上低于 10.7.0 的 ucbrowser
 * Android 上低于 11.2.0 的 ucbrowser
 * Android 上的 ucmini
 * Android 上的 Facebook 客户端
 */

/**
 * 纯前端判断是否在唤起黑名单内
 *
 * @return {boolean} 在黑名单则返回 true
 */
function isInBlackListFromClient() {
  if (!isClient) return false;

  var ucVersion = ua.getUCVersion();
  var isIOS = ua.os === 'IOS';
  var isAndroid = ua.os === 'ANDROID';
  // compareVersion(myVersion, LatestVersion)
  var isLowerThan = function isLowerThan(maxVersion) {
    return !ua.compareVersion(ucVersion, maxVersion);
  };

  if (isAndroid && ua.pf === 'UC_MINI') return true;
  if (isAndroid && ua.pf === 'FACEBOOK') return true;
  if (isAndroid && isUcBrowser() && isLowerThan('11.2.0')) return true;
  if (isIOS && isUcBrowser() && isLowerThan('10.7.0')) return true;

  return false;
}

module.exports = isInBlackListFromClient;